import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { phoneNumbersQueryKey } from './usePhoneNumbers'

interface ReleasePhoneNumberParams {
	workspaceId: string
	phoneNumberId: string
}

/**
 * Hook to release a phone number back to the pool
 */
export const useReleasePhoneNumber = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: async ({ workspaceId, phoneNumberId }: ReleasePhoneNumberParams) => {
			return authFetch(`workspaces/${workspaceId}/phone-numbers/${phoneNumberId}`, {
				method: 'DELETE',
			})
		},
		onSuccess: (_, { workspaceId }) => {
			queryClient.invalidateQueries({
				queryKey: phoneNumbersQueryKey(workspaceId),
			})
			toast.success('Phone number released to pool')
		},
		onError: (error: Error) => {
			toast.error(`Failed to release phone number: ${error.message}`)
		},
	})
}
